import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {MobileNavigationMenu, MobileNavItem} from './mobile-nav';
import {RouterModule} from '@angular/router';
import {NgbDropdownModule} from '../dropdown/dropdown.module';
import {SharedModule} from '../util/shared.module';

export {MobileNavigationMenu, MobileNavItem} from './mobile-nav';

@NgModule({
  declarations: [MobileNavigationMenu, MobileNavItem],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    SharedModule
  ],
  exports: [MobileNavigationMenu, MobileNavItem]
})
export class CloMobileNavigationModule {
}
